<template>
  <div>
    <RoleCreate/>
  </div>
</template>

<script>
import  RoleCreate  from '@/components/backend/role/RoleCreate.vue'

export default {
    name: 'RoleCreateView',
    components: {
      RoleCreate
    },
    data: () => {
      return {
      }
    },
    methods: {
    }
}
</script>
 